export enum ClientSubscriptionFreezeType {
    NoFreeze = -1,
    FreeFreeze = 1,
    PaidFreeze = 2
}

export enum ClientSubscriptionFreezeStatus {
    ScheduledFreeze = 1,
    FreezeInprogress = 2,
    FreezeCompleted = 3,
    FreezeCancelled = 4,
    FreezeStopped = 5
}